// 用户管理接口请求

import fetch from '../fetch';

import {
  // 会员等级
  MEMBER_GET_LEVEL_LIST,
  MEMBET_LEVEL_RIGHT,
  MEMBET_LEVEL_SAVE,
  MEMBET_DELETED_LEVEL,
  COMMODITY_CODE_LIST,
  COMMODITY_CODE_SAVE,
  COMMODITY_CODE_ENABLE,
  COMMODITY_CODE_DELETE,
  // 勋章管理
  MEDAL_MANAGE_UPDATE,
  MEDAL_MANAGE_GET_MEDAL_DAILY,
  MEDAL_MANAGE_LIST,
  MEDAL_MANAGE_GET_USER_MEDAL_LIST,
  // 积分管理
  GET_INTEGRAL_RULE_LIST,
  ADD_INTEGRAL_RULE,
  UPDATE_INTEGRAL_STATUS,
  GET_INTEGRAL_RULE_INFO,
  UPDATE_INTEGRAL_RULE,
  UPDATE_USER_INTEGRAL,
  GET_POINT_UPDATE_RECORD_LIST,
  GET_POINT_RECORD,
  // 会员列表
  MEMBER_LIST_NEW,
  LIST_EXPORT_RECORD_LIST,
  VIP_LIST_NEW_TO_EXCEL,
  LIST_EXPORT_RECORD_GET_BY_ID,
  // 黑名单管理
  MEMBER_BLACK_LIST,
  MEMBER_BLACK_LIST_DELETE,
  MEMBER_BLACK_LIST_SAVE,
  MEMBER_BLACK_LIST_UPDATE,
  // 额外积分规则
  GET_EXTRA_QUERY_LIST,
  GET_EXTRA_SAVE,
  GET_EXTRA_SET_STATUS,
  GET_EXTRA_QUERY_ONE,
  EXTRA_QUERY_CATE_GORY,
  EXTRA_QUERY_COMMONDITY,
  // 积分/成长值批量操作
  MEMBER_BATCH_TASK_LIST,
  MEMBER_BATCH_TASK_UPDATE,
  MEMBER_BATCH_TASK_STOP,
  // 任务中心
  INSERT_OR_UPDATE_USER_TASK,
  PROMOTE_UPDATE_USER_TASK,
  SELECT_USER_TASK_LIST,
  CHANGE_USER_TASK_STATUS,
  CHANGE_USER_TASK_SERIAL_NUMBER,
  PRECISION_PROMOTE_GET_USER_TASK_SIZE,
  SELECT_USER_TASK_POOL_LIST,
  INSERT_OR_UPDATE_USER_TASK_POOL,
  GET_IOT_PRODUCT_TYPE,
  DEVICE_TYPE_UPLOAD,
} from '../url';

/** 会员等级 */
/**
 * 等级列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getLevelList(data, brandInit) {
  return fetch({
    url: MEMBER_GET_LEVEL_LIST,
    method: 'get',
    params: data,
    isNoMsg: true,
    // 是否需要自定义品牌
    brandInit: brandInit,
  });
};

/**
 * 等级权益
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getLevelRight(data) {
  return fetch({
    url: MEMBET_LEVEL_RIGHT,
    method: 'get',
    params: data
  });
};

/**
 * 新增等级
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function addLevelSave(data, method) {
  let later;
  if (method === 'put') {
    // 新增
    later = '/save';
  } else {
    // 修改
    later = '/update';
  }
  return fetch({
    url: MEMBET_LEVEL_SAVE + later,
    method: 'post',
    data: data
  });
};

/**
 * 等级删除
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deletedLevel(data) {
  return fetch({
    url: MEMBET_DELETED_LEVEL,
    method: 'get',
    params: data
  });
};

/**
 * 积分规则列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getIntegralRuleList(data) {
  return fetch({
    url: GET_INTEGRAL_RULE_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 新增积分规则
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function addIntegralRule(data, isEdit) {
  let url = UPDATE_INTEGRAL_RULE;
  if (isEdit) {
    url = UPDATE_INTEGRAL_RULE;
  } else {
    url = ADD_INTEGRAL_RULE;
  }
  return fetch({
    url: url,
    method: 'post',
    data: data
  });
};

/**
 * 修改积分规则状态
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function updateIntegralStatus(data) {
  return fetch({
    url: UPDATE_INTEGRAL_STATUS,
    method: 'post',
    data: data
  });
};

/**
 * 积分规则列明细查询
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getIntegralRuleInfo(data) {
  return fetch({
    url: GET_INTEGRAL_RULE_INFO,
    method: 'GET',
    params: data
  });
};

/**
 * 积分修改 加减积分
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function integealUpdateEdit(data) {
  return fetch({
    url: UPDATE_USER_INTEGRAL,
    method: 'POST',
    data: data
  });
};

/**
 * 修改会员积分记录
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPointUpdateRecodeList(data) {
  return fetch({
    url: GET_POINT_UPDATE_RECORD_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 积分流水
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPointRecord(data) {
  return fetch({
    url: GET_POINT_RECORD,
    method: 'post',
    data: data
  });
};

/**
 * 会员列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getMemberListNew(data) {
  return fetch({
    url: MEMBER_LIST_NEW,
    method: 'POST',
    data: data
  });
};

/**
 * 会员列表导出记录列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function listExportRecordList(data) {
  return fetch({
    url: LIST_EXPORT_RECORD_LIST,
    method: 'POST',
    data: data
  });
};

/**
 * 导出部分查询结果Excel
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function listNewToExcel(file, data) {
  // console.log(file, data, '导出部分查询结果Excel');
  return fetch({
    url: VIP_LIST_NEW_TO_EXCEL,
    method: 'POST',
    data: file,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

/**
 * 会员列表获取导出地址
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function listExportRecordById(data) {
  return fetch({
    url: LIST_EXPORT_RECORD_GET_BY_ID,
    method: 'GET',
    params: data,
  });
};

/**
 * 查询黑名单列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getBlackList(data) {
  return fetch({
    url: MEMBER_BLACK_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 黑名单删除
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getBlackListDelete(data) {
  return fetch({
    url: MEMBER_BLACK_LIST_DELETE,
    method: 'post',
    data: data
  });
};

/**
 * 黑名单新增  编辑
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getBlackListSave(data) {
  let url = '';
  if (data.id) {
    // 编辑
    url = MEMBER_BLACK_LIST_UPDATE;
  } else {
    // 新增
    url = MEMBER_BLACK_LIST_SAVE;
  }
  return fetch({
    url: url,
    method: 'post',
    data: data
  });
};

/**
 * 查询积分规则列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getExtraQueryList(data) {
  return fetch({
    url: GET_EXTRA_QUERY_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 新增更新积分规则
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getExtraSave(data) {
  return fetch({
    url: GET_EXTRA_SAVE,
    method: 'post',
    data: data
  });
};

/**
 * 设置规则启用停用
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getExtraSetStatus(data) {
  return fetch({
    url: GET_EXTRA_SET_STATUS,
    method: 'post',
    data: data
  });
};

/**
 * 查询单条积分规则
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getExtraQueryOne(data) {
  return fetch({
    url: GET_EXTRA_QUERY_ONE,
    method: 'post',
    data: data
  });
};

/**
 * 获取商品品类
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getExtraCateGory(data) {
  return fetch({
    url: EXTRA_QUERY_CATE_GORY,
    method: 'post',
    data: data
  });
};

/**
 * 查询商品
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getExtraQueryCommontidy(data) {
  return fetch({
    url: EXTRA_QUERY_COMMONDITY,
    method: 'post',
    data: data
  });
};

/**
 * 商品编码列表查询
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getCommodityCodeList(data) {
  return fetch({
    url: COMMODITY_CODE_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 商品编码添加
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function saveCommodityCode(data) {
  return fetch({
    url: COMMODITY_CODE_SAVE,
    method: 'post',
    data: data
  });
};

/**
 * 商品编码启/停用
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function enableCommodityCode(data) {
  return fetch({
    url: COMMODITY_CODE_ENABLE,
    method: 'post',
    data: data
  });
};

/**
 * 商品编码删除
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deleteCommodityCode(data) {
  return fetch({
    url: COMMODITY_CODE_DELETE,
    method: 'post',
    data: data
  });
};

/**
 * 修改勋章
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function medalManageUpdate(data) {
  return fetch({
    url: MEDAL_MANAGE_UPDATE,
    method: 'post',
    data: data
  });
};

/**
 * 勋章统计报表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getMedalDaily(data) {
  return fetch({
    url: MEDAL_MANAGE_GET_MEDAL_DAILY,
    method: 'post',
    data: data
  });
};

/**
 * 勋章规则列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function medalManageList(data) {
  return fetch({
    url: MEDAL_MANAGE_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 用户勋章列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getUserMedalList(data) {
  return fetch({
    url: MEDAL_MANAGE_GET_USER_MEDAL_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 批量补发任务列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getMemberBatchTaskList(data) {
  return fetch({
    url: MEMBER_BATCH_TASK_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 批量补发会员成长值/积分
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function updateMemberBatchTask(data) {
  return fetch({
    url: MEMBER_BATCH_TASK_UPDATE,
    method: 'post',
    data: data,
    timeout: 120000,
  });
};

/**
 * 终止批量补发任务
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function stopMemberBatchTask(data) {
  return fetch({
    url: MEMBER_BATCH_TASK_STOP,
    method: 'get',
    params: data
  });
};

/**
 * 任务中心-新增或编辑任务
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function insertOrUpdateUserTask(data, id) {
  let url = INSERT_OR_UPDATE_USER_TASK;
  if (id) {
    url = PROMOTE_UPDATE_USER_TASK;
  }
  return fetch({
    url: url,
    method: 'post',
    data: data,
  });
};

/**
 * 任务中心-任务列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function selectUserTaskList(data) {
  return fetch({
    url: SELECT_USER_TASK_LIST,
    method: 'post',
    data: data,
  });
};

/**
 * 任务中心-停用启用任务
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function changeUserTaskStatus(data) {
  return fetch({
    url: CHANGE_USER_TASK_STATUS,
    method: 'post',
    data: data,
  });
};

/**
 * 任务中心-修改排序
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function changeUserTaskSerialNumber(data) {
  return fetch({
    url: CHANGE_USER_TASK_SERIAL_NUMBER,
    method: 'post',
    data: data,
  });
};

/**
 * 任务中心-根据eventId对应任务数量
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getUserTaskSize(data) {
  return fetch({
    url: PRECISION_PROMOTE_GET_USER_TASK_SIZE,
    method: 'post',
    data: data,
  });
};

/**
 * 任务中心-任务池列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function selectUserTaskPoolList(data) {
  return fetch({
    url: SELECT_USER_TASK_POOL_LIST,
    method: 'post',
    data: data,
  });
};

/**
 * 任务中心-任务池新增/修改
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function insertOrUpdateUserTaskPool(data) {
  return fetch({
    url: INSERT_OR_UPDATE_USER_TASK_POOL,
    method: 'post',
    data: data,
  });
};

/**
 * 任务中心-任务池新增/修改
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getIotProductType(data) {
  return fetch({
    url: GET_IOT_PRODUCT_TYPE,
    method: 'get',
    params: data,
  });
};

const memberManagement = {
  // 会员等级
  getLevelList,
  getLevelRight,
  addLevelSave,
  deletedLevel,
  getCommodityCodeList,
  saveCommodityCode,
  enableCommodityCode,
  deleteCommodityCode,
  // 勋章管理
  medalManageUpdate,
  getMedalDaily,
  medalManageList,
  getUserMedalList,
  // 积分管理
  getIntegralRuleList,
  addIntegralRule,
  updateIntegralStatus,
  getIntegralRuleInfo,
  integealUpdateEdit,
  getPointUpdateRecodeList,
  getPointRecord,
  // 会员列表
  getMemberListNew,
  listExportRecordList,
  listNewToExcel,
  listExportRecordById,
  // 黑名单管理
  getBlackList,
  getBlackListDelete,
  getBlackListSave,
  // 额外积分规则
  getExtraQueryList,
  getExtraSave,
  getExtraSetStatus,
  getExtraQueryOne,
  getExtraCateGory,
  getExtraQueryCommontidy,
  // 积分/成长值批量操作
  getMemberBatchTaskList,
  updateMemberBatchTask,
  stopMemberBatchTask,
  // 任务中心
  insertOrUpdateUserTask,
  selectUserTaskList,
  changeUserTaskStatus,
  changeUserTaskSerialNumber,
  getUserTaskSize,
  selectUserTaskPoolList,
  insertOrUpdateUserTaskPool,
  getIotProductType
};

export { memberManagement };
